import React, { useEffect, useState } from "react";
import { AutoComplete } from "antd";
import moment from "moment";
import {
  parseFormControlValue,
  isMobileScreen,
  getWindowWidth
} from "../../../services/utils";
import styles from "./yearSelector.scss";
import { InputSize, InputType } from "../../../models/enums";
import DatePickerMobile from "../DatePickerMobile";

const defaultSettings = {
  fromYear: 1900,
  inputSize: InputSize.large
};

const getYears = fromYear => {
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= fromYear; year -= 1) {
    years.push(year.toString());
  }

  return years;
};

const YearSelector = props => {
  const { title, isRequired, placeholder, settings } = props;

  const today = new Date();
  const minDate = new Date(props.settings.fromYear, 0, 1);
  const years = getYears(props.settings.fromYear);

  const getValueState = props => {
    const { value, field } = props;

    return {
      value: value ? new Date(value[field]).getFullYear().toString() : undefined
    };
  };

  const [state, setState] = useState(getValueState(props));

  useEffect(() => {
    setState(getValueState(props));
  }, [JSON.stringify(props.value)]);

  const handleSelect = year => {
    const { onChange, field } = props;
    const date = moment.utc({ year, month: 5 }); // set the date at middle of year

    onChange(parseFormControlValue([field], [date.toISOString()]));
  };

  const handleBlur = value => {
    const { onChange } = props;

    if (!years.includes(value)) {
      onChange(undefined);
    } else {
      handleSelect(value);
    }
  };

  const handleSearch = value => {
    setState({
      value,
      // @ts-ignore
      dataSource: years.filter(year => year.startsWith(value))
    });
  };

  // @ts-ignore
  const { dataSource, value } = state;

  const isMobile = isMobileScreen(getWindowWidth());

  return isMobile ? (
    <DatePickerMobile
      {...props}
      controlType={InputType.year}
      max={today}
      min={minDate}
    />
  ) : (
    <div className={styles.yearSelector}>
      <span
        className={`control-title ${isRequired ? "required" : ""} ${
          styles.title
        }`}
      >
        {title}
      </span>
      <AutoComplete
        size={settings.inputSize}
        dataSource={dataSource || years}
        value={value}
        // @ts-ignore
        onBlur={handleBlur}
        onSelect={handleSelect}
        onSearch={handleSearch}
        placeholder={placeholder}
      />
    </div>
  );
};

YearSelector.defaultProps = {
  placeholder: "",
  title: "",
  isRequired: false,
  settings: defaultSettings,
  onChange: () => null
};

export default YearSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/YearSelector/YearSelector.tsx